import React, { Fragment, useContext } from 'react'
import { Button, Icon, Popup, Step } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../../../App/stores/RootStore'
import RequestReviewNoteForm from '../../../../notes/form/RequestReviewNote/RequestReviewNoteForm';
import LoadingComponent from '../../../../../App/layout/LoadingComponent';

const RequestReviewSteps = () => {

    const rootStore = useContext(RootStoreContext);
    const { requestResult, validatedResult, GetStep, RequestReview, validating } = rootStore.requestReviewStore;
    const { openModal } = rootStore.modalStore;

    return (

        <Fragment>
            <Popup size='tiny'
                content={RequestReview?.noteCount}
                trigger={
                    <Button
                        size='tiny'
                        color='yellow'
                        onClick={() => openModal(<RequestReviewNoteForm
                            requestReviewNoteId={''}
                            noteType={''}
                            note={''}
                            requestReviewId={RequestReview!.id} />)} >
                        <Icon name="sticky note" />
                    </Button>
                }
            />
            <Step.Group size='tiny'>
                <LoadingComponent active={validating} content={"Validating Review..."}></LoadingComponent>
                {/*<Step*/}

                {/*    icon='sticky note'*/}
                {/*    link*/}
                {/*    color='yellow'*/}
                {/*    onClick={() => openModal(<RequestReviewNoteForm*/}
                {/*        requestReviewNoteId={''}*/}
                {/*        noteType={''}*/}
                {/*        note={''}*/}
                {/*        requestReviewId={RequestReview!.id} />)}*/}
                {/*    // disabled={notComplete}*/}
                {/*    title='Add Note'*/}
                {/*    description={RequestReview?.noteCount}*/}
                {/*/>*/}
                <Step

                    icon='check circle'
                    link
                    color='green'
                    onClick={() => GetStep(1)}
                    // disabled={notComplete}
                    title='Validate'
                    description='Validate The Review'
                />
                <Step
                    icon='list ul'
                    link
                    onClick={() => GetStep(2)}
                    disabled={!validatedResult}
                    title='Result'
                    description='Choose the Review Result'
                />

                <Step
                    icon='sticky note'
                    link
                    onClick={() => GetStep(3)}
                    disabled={!requestResult}
                    title='Note'
                    description='Add a Review Completion Note'
                />
                <Step
                    icon='clipboard check'
                    link
                    onClick={() => GetStep(4)}
                    disabled={!requestResult}
                    title='Submit'
                    description='Complete the request Review'
                />
            </Step.Group>
        </Fragment>
    );
}
export default observer(RequestReviewSteps);